import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Cell } from 'recharts';

const WinRateChart = ({ data }) => {
  const colors = {
    'T20': 'hsl(var(--primary))',
    'ODI': 'hsl(var(--success))',
    'Test': 'hsl(var(--warning))'
  };

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload?.length) {
      return (
        <div className="bg-card border border-border rounded-lg shadow-lg p-3">
          <p className="text-sm font-medium text-foreground mb-1">{label}</p>
          <p className="text-sm text-primary">
            Win Rate: <span className="font-semibold">{payload?.[0]?.value}%</span>
          </p>
          <p className="text-sm text-muted-foreground">
            Total Predictions: {payload?.[0]?.payload?.total}
          </p>
        </div>
      );
    }
    return null;
  };

  if (!data || data?.length === 0) {
    return (
      <div className="h-64 flex items-center justify-center text-muted-foreground">
        <p>No win rate data available</p>
      </div>
    );
  }

  return (
    <ResponsiveContainer width="100%" height={300}>
      <BarChart data={data} margin={{ top: 5, right: 10, left: -20, bottom: 5 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--border))" />
        <XAxis 
          dataKey="format" 
          stroke="hsl(var(--muted-foreground))"
          style={{ fontSize: '12px' }}
          tick={{ fill: 'hsl(var(--muted-foreground))' }}
        />
        <YAxis 
          stroke="hsl(var(--muted-foreground))"
          style={{ fontSize: '12px' }}
          tick={{ fill: 'hsl(var(--muted-foreground))' }}
          domain={[0, 100]}
        />
        <Tooltip content={<CustomTooltip />} />
        <Legend 
          wrapperStyle={{ fontSize: '14px' }}
        />
        <Bar 
          dataKey="winRate" 
          name="Win Rate %"
          radius={[8, 8, 0, 0]}
        >
          {data?.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={colors?.[entry?.format] || 'hsl(var(--primary))'} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};

export default WinRateChart;